import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { TabsLoader } from './common/tabs-loader';

export const QuoteDetailPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader />
      <TabsLoader />
      <br />
      <TableLoader hideActions hideFilters />
    </div>
  );
};
